import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Receipt as ReceiptIcon } from "lucide-react";

/**
 * Diálogo de confirmação centralizado, com ícone de "tudo certo" e botão OK.
 * Usado em ações importantes que o usuário pode não notar no toast (ex:
 * pedido feito, venda finalizada).
 *
 * Props:
 *  - open: boolean
 *  - title: string (default "Pedido feito")
 *  - description: string (opcional)
 *  - onClose: () => void
 *  - onPrintReceipt?: () => void  // mostra botão "Imprimir cupom térmico"
 */
export default function ConfirmationDialog({ open, title = "Pedido feito", description, onClose, onPrintReceipt }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent
        className="max-w-sm text-center py-8 px-6 sm:rounded-2xl"
        data-testid="confirmation-dialog"
      >
        <div className="flex justify-center mb-3">
          <div className="w-16 h-16 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center animate-in fade-in zoom-in duration-300">
            <CheckCircle2 size={36} className="text-emerald-600 dark:text-emerald-400"/>
          </div>
        </div>
        <h2 className="font-display text-2xl tracking-tight" data-testid="confirmation-title">{title}</h2>
        {description && <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-1">{description}</p>}
        {onPrintReceipt && (
          <Button
            onClick={onPrintReceipt}
            variant="outline"
            className="w-full mt-5 h-11 border-emerald-500/40 text-emerald-700 dark:text-emerald-300 hover:bg-emerald-50 dark:hover:bg-emerald-950/30"
            data-testid="confirmation-print-thermal"
          >
            <ReceiptIcon size={16} className="mr-1.5"/> Imprimir cupom térmico
          </Button>
        )}
        <Button
          onClick={onClose}
          className={`w-full ${onPrintReceipt ? "mt-2" : "mt-6"} bg-[#0A0A0A] hover:bg-black text-white h-11`}
          data-testid="confirmation-ok-button"
        >
          OK
        </Button>
      </DialogContent>
    </Dialog>
  );
}
